import { useEffect, useState } from "react";
function Testimonials() {
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    const carouselItems = document.getElementsByClassName("carousel-item");
    let maxHeight = 0;

    for (let i = 0; i < carouselItems.length; i++) {
      const slideHeight = carouselItems[i].clientHeight;
      if (slideHeight > maxHeight) {
        maxHeight = slideHeight;
      }
    }

    setMaxHeight(maxHeight);
  }, []);
  return (
    <section class="l-contain l-section l-section--separated ">
      <h2 class="u-small-title">RECOMMENDATIONS AND COMPLIMENTS</h2>
      <div className="testimonials pt-5">
        <div
          className="  d-flex justify-content-center"
          style={{ height: `${maxHeight}px` }}>
          <div
            id="carouselExampleIndicators"
            class="carousel slide "
            data-bs-ride="carousel">
            <div class="carousel-indicators">
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="0"
                class="active"
                aria-current="true"
                aria-label="Slide 1"></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="1"
                aria-label="Slide 2"></button>
              <button
                type="button"
                data-bs-target="#carouselExampleIndicators"
                data-bs-slide-to="2"
                aria-label="Slide 3"></button>
            </div>
            <div class="carousel-inner">
              <div class="carousel-item active">
                <div className="w-100">
                  <blockquote>
                    <p>
                      Ayomide is a detailed oriented product Manager.
                      Understands how to lead cross functional teams in such an
                      amazing manner. She has proven over time to be a critical
                      thinker and one who makes creative decisions drawn out of
                      well researched data. I would recommend her for any
                      organization and I know she will do well
                    </p>
                  </blockquote>
                  <p className="text-center">
                    - <strong>Eno Peters</strong>
                  </p>
                  <p className="text-center">
                    <em>(10x Tutor, Project Manager)</em>
                  </p>
                  <hr />
                </div>
              </div>
              <div class="carousel-item">
                <div className="w-100">
                  <blockquote>
                    <p>Hey Ayomide,</p>
                    <p>
                      Nice documentation. I could see intentionality and effort
                      in capturing important requirements and necessary pointers
                      to further drive business objectives of the client.
                    </p>
                    <p>Keep&nbsp;it&nbsp;up!</p>
                  </blockquote>
                  <p className="text-center">
                    - <strong>Christopher Okonkwo - PMP®</strong>
                  </p>
                  <p className="text-center">
                    <em>(Feedback on the documentation of Project Alpha)</em>
                  </p>
                  <hr />
                </div>
              </div>
              <div class="carousel-item">
                <div className="w-100">
                  <blockquote>
                    <p>
                      Thank you a lot Ayomide Alajogun, I really appreciate your
                      effort, and your commitment, and actually I learned a lot
                      from you😍😍
                    </p>
                  </blockquote>
                  <p className="text-center">
                    <strong>- Dareen Atta</strong>
                  </p>
                  <p className="text-center">
                    <em>
                      (Data Science Fellow, Women Techsters Fellowship 2023)
                    </em>
                  </p>
                  <hr />
                </div>
              </div>
            </div>
            <button
              class="carousel-control-prev d-none d-lg-flex"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="prev">
              <span
                class="carousel-control-prev-icon"
                aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button
              class="carousel-control-next d-none d-lg-flex"
              type="button"
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide="next">
              <span
                class="carousel-control-next-icon"
                aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
